module.exports = __webpack_public_path__ + "static/img/bg.45d037c4.jpg";